import { render, staticRenderFns } from "./PageTen.vue?vue&type=template&id=5345788d&scoped=true"
import script from "./PageTen.vue?vue&type=script&lang=js"
export * from "./PageTen.vue?vue&type=script&lang=js"
import style0 from "./PageTen.vue?vue&type=style&index=0&id=5345788d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345788d",
  null
  
)

export default component.exports